const storage: Storage = (() => {
  try {
    window.sessionStorage.setItem("t", "t");
    window.sessionStorage.removeItem("t");
    return window.sessionStorage;
  } catch (e) {
    const w = window as Window & typeof globalThis & { storage: {} };
    w.storage = {};
    return {
      setItem: (key, value) => {
        w.storage[key] = value;
      },
      getItem: (key) => w.storage[key],
      removeItem: (key) => {
        delete w.storage[key];
      },
      length: 0,
      clear: () => {
        w.storage = {};
      },
      key: () => null,
    };
  }
})();

export default storage;
